import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const FloatingButtons = () => {
  const whatsappMessage = encodeURIComponent(
    `Hello Centurio Prime Team,\n\nI would like to reserve a snooker table.\n\nPreferred Date: [Please Enter Date]\nPreferred Time: [Please Enter Time]\nNumber of Players: [Enter Number]\n\nKindly confirm availability.\n\nThank you.`
  );

  return (
    <>
      {/* WhatsApp Button (Bottom Right) */}
      <a
        href={`https://wa.me/923016697234?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:flex fixed bottom-8 right-8 z-50 w-16 h-16 rounded-full bg-black border-2 border-gold items-center justify-center text-gold hover:bg-gold hover:text-black transition-all duration-300 hover:scale-110 gold-glow-hover shadow-lg"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp-button"
      >
        <MessageCircle className="w-7 h-7" />
      </a>

      {/* Call Button (Bottom Left - Mobile Only) */}
      <a
        href="tel:+923016697234"
        className="md:hidden fixed bottom-8 left-8 z-50 w-16 h-16 rounded-full bg-black border-2 border-gold flex items-center justify-center text-gold hover:bg-gold hover:text-black transition-all duration-300 hover:scale-110 gold-glow-hover shadow-lg"
        aria-label="Call"
        data-testid="floating-call-button"
      >
        <Phone className="w-7 h-7" />
      </a>
    </>
  );
};

export default FloatingButtons;
